export const LEGAL_ADMIN = {
  kind: 'initiative_group' as const,
  displayName: 'Инициативная группа проекта «Прогресс»',
  brandName: 'Прогресс',
  siteHost: 'progress-sn.ru',
  contactEmail: 'progress-sn.ru@mail.ru',
} as const

export const LEGAL_DOCUMENT_VERSION = '1.0'
export const LEGAL_DOCUMENT_EFFECTIVE_DATE = '28.07.2026'
